<template>

  <b-card-code style="background-color:rgba(255,255,255, 0.9);">
    <!-- UserEdit.vue -->
    <UserAdd
      @fetch="getUser()"
    />
    <!-- UserAdd.vue -->
    <UserEdit
      ref="childref"
      @fetch="getUser()"
    />
    <!-- -------------- -->
    <b-row>
      <b-col
        md="4"
        sm="4"
        lg="3"
        xs="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <!-- style="margin-left: 15px;" -->
        <label style="font-size:14px">Search</label>
        <b-input-group
          style="padding-left:14px;"
          size="sm"
        >
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
            label-cols-sm="12"
            label-cols-md="2"
            label-cols-lg="2"
            style="background-color:rgba(255,255,255, 0.9);"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>

      </b-col>
      <b-col
        md="8"
        sm="12"
        lg="9"
        xs="12"
        class="text-sm-right mb-1"
      >
        <b-button
          id="toggle-btn"
          v-b-modal="'modalAdd'"
          variant="primary"
        >
          Add User
        </b-button>
      </b-col>

      <b-col cols="12">
        <b-table
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template
            #cell(edit)="data"
          >
            <b-link
              v-b-modal="'modalEdit'"
              @click="$refs.childref.sendInfo(data.item.id)"
            ><feather-icon
              class="text-warning"
              icon="EditIcon"
              size="20"
            />{{ data.value }}
            </b-link>
          </template>
          <template #cell(delete)="data">
            <b-link
              @click.prevent="remove(data.item.id)"
            >
              <feather-icon
                class="text-danger"
                icon="XSquareIcon"
                size="20"
              />
              {{ data.value }}
            </b-link>
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
      >

        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
              style="background-color:rgba(255,255,255, 0.9);"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
    <!-- <template #code>
      {{ codeFeedbackHelper }}
    </template> -->
    </b-row>
  </b-card-code>
</template>

<script>
import {
  BTable, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BLink, BCardBody, BButton, BInputGroupAppend,
  BInputGroup,
  // BInputGroupPrepend,
  BFormInput,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import UserEdit from './UserEdit.vue'
import UserAdd from './UserAdd.vue'

export default {
  components: {
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BLink,
    UserEdit,
    UserAdd,
    BCardCode,
    BCardBody,
    BButton,
    BInputGroupAppend,
    // BFormText,
    // BFormDatalist,
    // BFormInvalidFeedback,
    BInputGroup,
    // BInputGroupPrepend,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
        // codeFeedbackHelper,
      },
      addData: {
        id: '',
        username: '',
        firstname: '',
        lasttname: '',
        role: '',
        password: '',
      },
      userId: '',
      occupationID: '',
      fields: [
        {
          key: 'edit', label: 'Edit', requiresAdmin: true,
        },
        {
          key: 'username', label: 'Username', sortable: true,
        },
        {
          key: 'firstname', label: 'First Name', sortable: true,
        },
        { key: 'lastname', label: 'Last Name', sortable: true },
        { key: 'role', label: 'Role', sortable: true },
        { key: 'delete', label: 'Delete', requiresAdmin: true },
      ],
      items: [],
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    validation() {
      return this.userId.length > 4 && this.userId.length < 13
    },
    validationOccupation() {
      return this.occupationID.length > 1
    },
  },
  mounted() {
    // Set the initial number of items
    this.getUser()
    setInterval(() => {
      this.getUser()
    }, 7000)
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getUser() {
      axios
        .get('/get-userNPT')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    remove(id) {
      this.$swal({
        title: '<span style="color:#000000">Are you sure?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const selectedID = id
            await axios.post('/delete-userNPT', { id: selectedID })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">Deleted successfully.</span>',
              // text: 'Deleted successfully.',
              showConfirmButton: false,
              timer: 1000,
            })
            this.getUser()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' You clicked the button!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
